import styled from 'styled-components';
import PropTypes from 'prop-types';
import bundleBackground from '../../../images/Oval.svg';

const NavIconContainerStyled = styled.div`
  position: relative;
  transition: transform 0.4s ease;
  &:after {
    display: ${props => (props.newsNotification ? 'block' : 'none')};
    content: '';
    width: 8px;
    height: 8px;
    position: absolute;
    background: #e62771;
    border-radius: 50%;
    right: 2px;
    top: 0px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const NewsItemsStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const NewsItemsHeaderEnd = styled.div`
  height: 60px;
  width: 100%;
  background: url(${bundleBackground});
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
`;

const NewsStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  cursor: pointer;
  &:hover {
    ${NavIconContainerStyled} {
      transform: scale(1.2) rotate(10deg);
    }
    span {
      transform: translateX(3px);
    }
  }
  span {
    font-size: 14px;
    font-family: 'cerapro';
    color: #ffffff;
    margin-left: 8px;
    transition: transform 0.4s ease;
    display: none;
    @media (min-width: 768px) {
      display: block;
    }
  }
`;

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  transform: translateY(-40px);
  padding-left: 32px;
  padding-right: 32px;
`;

const LoadingWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  padding: 0 20px 0 20px;
`;

NavIconContainerStyled.propTypes = {
  newsNotification: PropTypes.bool.isRequired,
};

export {
  NewsStyled,
  NavIconContainerStyled,
  NewsItemsStyled,
  NewsItemsHeaderEnd,
  ErrorWrapper,
  LoadingWrapper,
};
